<template>
  <div ref="component" class="cubeSpace home-section">
    <section class="ancho grid-efi">
      
      <aside>
        <h1 class="fuente-posm">Ayudamos a tu negocio a crear experiencias memorables.</h1>
        <button class="button-outline font- hover-boton_mod fuente-nova2 btn-descubre" @click="openContactModal">
          Descubre Como
        </button>
      </aside>

      <aside class="aside-figure">
        <transition name="hero-slide" mode="out-in">
          <div
            class="hero-image"
            :key="'hero-' + heroIndex"
            :style="{ backgroundImage: `url(${heroSlides[heroIndex].image})` }"
          >
            <!-- Notificación flotante -->
            <transition name="notification-pop">
              <div class="notification-card" v-if="showNotification" :key="'notif-' + heroIndex">
                <div class="notification-icon">
                  <img :src="heroSlides[heroIndex].logo" :alt="heroSlides[heroIndex].name">
                </div>
                <div class="notification-content">
                  <strong>{{ heroSlides[heroIndex].name }}</strong>
                  <p>{{ heroSlides[heroIndex].message }}</p>
                </div>
              </div>
            </transition>
          </div>
        </transition>
        <p class="fuente-posm">{{ heroSlides[heroIndex].tagline }}</p>
      </aside>

      <!-- Carrusel Social Proof -->
      <section class="social-proof">
        <transition name="fade" mode="out-in">
          <aside class="social-proof__logo" :key="'logo-' + currentIndex">
            <figure>
              <img :src="partners[currentIndex].logo" :alt="partners[currentIndex].name">
            </figure>
          </aside>
        </transition>

        <div class="linea-divisor"></div>

        <transition name="fade" mode="out-in">
          <aside class="social-proof__text" :key="'text-' + currentIndex">
            <p>{{ partners[currentIndex].description }}</p>
          </aside>
        </transition>
      </section>

    </section>
  </div>
  
  <ContactModal />
</template>

<script>
import ContactModal from '@/components/modal/Contact.vue'

export default {
  components: { ContactModal },
  name: "page1",
  emits: ["sendAction"],
  
  props: {
    action: {
      type: Object,
      default: () => {},
    },
    pos: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      // Carrusel Social Proof
      currentIndex: 0,
      intervalId: null,

      // Carrusel Hero
      heroIndex: 0,
      heroIntervalId: null,
      showNotification: false,
      notificationTimeoutId: null,

      heroSlides: [
        {
          image: require('@/assets/images/carrusel/david.jpg'),
          logo: require('@/assets/images/carrusel/logos/sushi-roll.png'),
          name: 'David',
          message: 'Tu mesa está lista, puedes dirigirte al área de hostess.',
          tagline: 'Consiente a tus clientes.'
        },
        {
          image: require('@/assets/images/carrusel/luis.jpg'),
          logo: require('@/assets/images/carrusel/logos/parroquia.png'),
          name: 'Luis',
          message: 'Hace tiempo que no nos visitas. Tu postre favorito va por nuestra cuenta.',
          tagline: 'Haz que vuelvan.'
        },
        {
          image: require('@/assets/images/carrusel/vane.jpg'),
          logo: require('@/assets/images/carrusel/logos/bostons.png'),
          name: 'Vane',
          message: 'Tu reservación para 4 personas ha sido confirmada.',
          tagline: 'Fluye sin fricción.'
        },
        {
          image: require('@/assets/images/carrusel/eduardo.jpg'),
          logo: require('@/assets/images/carrusel/logos/efisense.png'),
          name: 'Eduardo',
          message: 'Un cliente tuvo una mala experiencia. Contáctalo ahora.',
          tagline: 'Responde al instante.'
        },
        {
          image: require('@/assets/images/carrusel/julio.jpg'),
          logo: require('@/assets/images/carrusel/logos/mb-chicken.png'),
          name: 'Julio',
          message: 'Tu cumpleaños se acerca. Te esperamos con un regalo especial.',
          tagline: 'Hazlo memorable.'
        },
        {
          image: require('@/assets/images/carrusel/dani.jpg'),
          logo: require('@/assets/images/carrusel/logos/bostons.png'),
          name: 'Dani',
          message: 'Tu pedido está en camino. Llegará en aproximadamente 15 minutos.',
          tagline: 'Aumenta tus ventas.'
        },
      ],

      partners: [
        {
          name: 'Oracle',
          logo: require('@/assets/images/oracle.png'),
          description: 'Efisense es Partner Certificado, con lo cual respaldamos la seguridad de tus operaciones.'
        },
        {
          name: 'Bostons',
          logo: require('@/assets/images/bostons.png'),
          description: 'Implementación exitosa en la mayoría de sus sucursales a nivel nacional, consolidando operaciones.'
        },
        {
          name: 'Soft',
          logo: require('@/assets/images/soft.png'),
          description: 'Implementación exitosa en múltiples sucursales, optimizando la gestión operativa.'
        },
        {
          name: 'SushiRoll',
          logo: require('@/assets/images/sushiroll.png'),
          description: 'Mejoró significativamente la experiencia de espera de sus comensales implementando Flow'
        },
        {
          name: 'Mb Chicken',
          logo: require('@/assets/images/mb.png'),
          description: 'Franquicia canadiense que mide la satisfacción del cliente con encuestas automáticas en todas sus sucursales en México.'
        },
        {
          name: 'Rappi',
          logo: require('@/assets/images/rappi.png'),
          description: 'Integramos con el equipo de Rappi, automatizando el ingreso de sus pedidos de forma automática, reduciendo tiempos de espera.'
        },
        {
          name: 'Adyen',
          logo: require('@/assets/images/adyen.png'),
          description: 'Integración pionera con su terminal de pagos en México, ofreciendo procesamiento avanzado y confiable'
        },
        {
          name: 'Uber',
          logo: require('@/assets/images/uber.png'),
          description: 'Partnership tecnológico que permite el desarrollo de soluciones avanzadas para restaurantes'
        },
        {
          name: 'Parroquia',
          logo: require('@/assets/images/parroquia.png'),
          description: 'Digitalización completa de su sistema de facturación, adaptado a las necesidades organizacionales específicas.'
        },
        {
          name: 'Xenial',
          logo: require('@/assets/images/xenial.png'),
          description: 'Compatibilidad nativa con su plataforma POS, asegurando operación continua sin interrupciones técnicas.'
        },
        {
          name: 'Videre',
          logo: require('@/assets/images/videre.png'),
          description: 'Clínica oftalmológica que redujo 20% sus ausencias de pacientes optimizando la gestión de citas'
        },
        {
          name: 'Givex',
          logo: require('@/assets/images/givex.png'),
          description: 'Conectividad directa con su sistema de pagos, facilitando el flujo unificado de información.'
        },
        {
          name: 'Izakaya',
          logo: require('@/assets/images/izakaya.png'),
          description: 'Mejoró la experiencia de espera de sus clientes con Flow, incrementando la satisfacción general.'
        },
        {
          name: 'Positouch',
          logo: require('@/assets/images/positouch.png'),
          description: 'Compatibilidad total con su POS, garantizando una integración sin complicaciones.'
        },
      ],
    };
  },

  watch: {
    action: {
      handler() {
        this.getAction();
      },
      deep: true,
    },
  },

  mounted() {
    this.getComponentHeight();
    this.startCarousel();
    this.startHeroCarousel();
  },

  beforeUnmount() {
    this.stopCarousel();
    this.stopHeroCarousel();
  },

  methods: {
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, 6000); /* ORIGINAL: 4000 - reversible */
    },

    stopCarousel() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    nextSlide() {
      /* ORIGINAL: this.currentIndex = (this.currentIndex + 1) % this.partners.length; - reversible */
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * this.partners.length);
      } while (newIndex === this.currentIndex);
      this.currentIndex = newIndex;
    },

    // ========== Hero Carousel Methods ==========
    getRandomInterval() {
      // Retorna un tiempo aleatorio entre 12 y 16 segundos
      return Math.floor(Math.random() * 4000) + 12000; // 12000-16000ms
    },

    getRandomIndex() {
      // Retorna un índice aleatorio diferente al actual
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * this.heroSlides.length);
      } while (newIndex === this.heroIndex);
      return newIndex;
    },

    startHeroCarousel() {
      // Mostrar notificación inicial después de 1 segundo
      this.notificationTimeoutId = setTimeout(() => {
        this.showNotification = true;
      }, 1000);

      // Programar el primer cambio con tiempo aleatorio
      this.scheduleNextHeroSlide();
    },

    scheduleNextHeroSlide() {
      const randomTime = this.getRandomInterval();
      this.heroIntervalId = setTimeout(() => {
        this.nextHeroSlide();
      }, randomTime);
    },

    stopHeroCarousel() {
      if (this.heroIntervalId) {
        clearTimeout(this.heroIntervalId);
        this.heroIntervalId = null;
      }
      if (this.notificationTimeoutId) {
        clearTimeout(this.notificationTimeoutId);
        this.notificationTimeoutId = null;
      }
    },

    nextHeroSlide() {
      // 1. Ocultar notificación (animación dura 0.6s)
      this.showNotification = false;

      // 2. Después de que sale la notificación, cambiar imagen
      setTimeout(() => {
        this.heroIndex = this.getRandomIndex(); // Orden aleatorio

        // 3. Después de que entra la imagen (1.2s), mostrar notificación
        setTimeout(() => {
          this.showNotification = true;
          // 4. Programar siguiente slide con tiempo aleatorio
          this.scheduleNextHeroSlide();
        }, 1400);
      }, 700);
    },

    openContactModal() {
      const modalEl = document.getElementById('contactModal');
      if (modalEl) {
        import('bootstrap').then(({ Modal }) => {
          const contactModal = new Modal(modalEl);
          contactModal.show();
        });
      }
    },

    getComponentHeight() {
      let component = this.$refs.component;
      this.$emit("sendAction", {
        action: "setHeight",
        data: { pos: this.pos, val: component.offsetHeight },
      });
    },

    getAction() {
      switch (this.action?.type) {
        case "?":
          break;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.cubeSpace {
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-efi {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr auto; /* NUEVO - contenido arriba, carrusel abajo */
  place-items: center;
  width: 100%;
  max-width: 1800px;
  height: 100%; /* NUEVO - altura completa */
  padding: 0 2%; /* ORIGINAL: sin padding - reversible */
}

.grid-efi aside {
  max-width: 800px;
  height: auto;
  margin: 15px;
}

.grid-efi aside:first-child {
  justify-self: start; /* NUEVO - alinea el aside del título a la izquierda */
  margin-left: 0; /* NUEVO - quita margen izquierdo para alinear con carrusel */
}

.btn-descubre {
  margin-left: 15px; /* NUEVO - mueve botón a la derecha sin afectar título */
}

.grid-efi h1 {
  font-size: clamp(26px, 2.8vw, 45px); /* ORIGINAL: clamp(30px, 4vw, 65px) - reversible */
  line-height: 1.1;
  color: var(--color-2);
  margin-bottom: 30px;
}

.grid-efi aside figure {
  max-width: 800px;
  height: auto;
  margin: 0;
}

.grid-efi aside figure img {
  width: 100%;
}

.aside-figure {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  text-align: center;
  max-width: none; /* Sobreescribe el max-width de .grid-efi aside */
  width: 100%;
}

.aside-figure p {
  font-size: clamp(16px, 2vw, 35px);
  margin-top: 20px;
  color: var(--color-2);
}

/* ========== Hero Image con Notificación ========== */
.hero-image {
  position: relative;
  width: 620px; /* ORIGINAL: 550px - más ancho */
  height: 400px; /* ORIGINAL: 420px - más bajo para proporción panorámica */
  background-size: cover;
  background-position: center;
  border-radius: 24px;
  overflow: hidden;
}

.notification-card {
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%); /* Centra horizontalmente */
  width: 80%; /* ORIGINAL: 70% - reversible */
  background: rgba(255, 255, 255, 0.80);
  backdrop-filter: blur(10px);
  border-radius: 30px; /* Más redondeado */
  padding: 20px 25px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.notification-icon {
  width: 75px;
  height: 75px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.notification-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.notification-content {
  flex: 1;
  text-align: left;
}

.notification-content strong {
  display: block;
  font-size: 18px; /* Más grande */
  color: #1a1a1a;
  margin-bottom: 2px;
}

.notification-content p {
  font-size: 15px !important; /* Más grande */
  color: #666;
  margin: 0 !important;
  line-height: 1.4;
}

/* ========== Social Proof Carrusel ========== */
.social-proof {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* ORIGINAL: center - reversible */
  /* max-width: 800px; ORIGINAL - removido para alinear a la izquierda */
  grid-column: 1 / -1; /* Ocupa las 2 columnas */
  margin-top: auto; /* Empuja hacia abajo */
  padding-bottom: 8%; /* ORIGINAL: margin-top: 90px, margin-bottom: 40px - reversible */
  padding-left: 2%; /* NUEVO - alineado con el título, reversible */
  width: 100%;
}

.social-proof__logo {
  margin: 0; /* NUEVO - quita margen heredado del aside */
  min-width: 150px; /* NUEVO - evita brincos al cambiar logos */
  height: 60px; /* NUEVO - altura fija para evitar brincos */
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-proof__logo figure {
  width: auto; /* ORIGINAL: 150px - ahora auto para ajustar al logo */
  height: 60px; /* ORIGINAL: auto - reversible */
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-proof__logo figure img {
  margin: 0;
  max-width: 100%;
  max-height: 60px; /* 100% del contenedor */
  width: auto;
  object-fit: contain;
}

.social-proof__text {
  width: clamp(250px, 30vw, 500px); /* NUEVO - ancho responsivo */
  max-width: none;
  margin: 0;
  min-height: 45px; /* NUEVO - altura mínima para evitar brincos */
  display: flex;
  align-items: center;
}

.social-proof__text p {
  font-size: clamp(10px, 1vw, 16px);
  margin: 0;
  color: #585858; /* NUEVO - color de texto */
}

.linea-divisor {
  height: 70px;
  width: 5px;
  background-color: #DBDBDB;
  margin: 0px 20px 0px 15px; /* ORIGINAL: 0px 20px - reducido izquierda 25% */
}

/* ========== Transiciones ========== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease; /* ORIGINAL: 0.4s - reversible */
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ========== Hero Slide Transition (derecha a izquierda, elegante) ========== */
.hero-slide-enter-active {
  animation: slideInFromRight 1.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.hero-slide-leave-active {
  animation: slideOutToLeft 0.9s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideInFromRight {
  from {
    transform: translateX(60%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOutToLeft {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-20%);
    opacity: 0;
  }
}

/* ========== Notification Pop Transition (suave y elegante) ========== */
.notification-pop-enter-active {
  animation: notificationSlideUp 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.notification-pop-leave-active {
  animation: notificationSlideDown 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes notificationSlideUp {
  0% {
    transform: translateX(-50%) translateY(80%);
    opacity: 0;
  }
  70% {
    transform: translateX(-50%) translateY(-4px);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

@keyframes notificationSlideDown {
  from {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
  to {
    transform: translateX(-50%) translateY(60%);
    opacity: 0;
  }
}


/* ========== Responsive ========== */
@media screen and (max-width: 1280px) {
  .grid-efi {
    margin-top: 70px;
  }

  .social-proof {
    margin-top: 0px;
  }
}

@media screen and (max-width: 768px) {
  .cubeSpace {
    height: 100vh;
    padding: 0;
    overflow: hidden;
  }

  .grid-efi {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    text-align: center;
    margin-top: 0;
    padding: 0 5%;
    gap: 0;
    height: calc(100vh - 80px);
    align-content: start;
    padding-top: 20px;
  }

  .grid-efi aside:first-child {
    justify-self: center;
    order: 1;
    margin: 0 0 10px 0;
  }

  .grid-efi h1 {
    font-size: clamp(20px, 5.5vw, 28px);
    margin-bottom: 12px;
  }

  .btn-descubre {
    margin-left: 0;
  }

  .aside-figure {
    order: 2;
    width: 100%;
    margin: 0;
    justify-content: center;
  }

  .hero-image {
    width: 85vw;
    max-width: 350px;
    height: 240px;
    border-radius: 18px;
  }

  .aside-figure p {
    font-size: clamp(13px, 3.5vw, 18px);
    margin-top: 8px;
    margin-bottom: 15px;
  }

  .notification-card {
    width: 90%;
    padding: 10px 12px;
    border-radius: 18px;
    bottom: 12px;
    gap: 8px;
  }

  .notification-icon {
    width: 45px;
    height: 45px;
    border-radius: 10px;
  }

  .notification-content strong {
    font-size: 13px;
  }

  .notification-content p {
    font-size: 11px !important;
    line-height: 1.3;
  }

  .social-proof {
    order: 3;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px 5%;
    padding-bottom: 25px;
    gap: 8px;
  }

  .social-proof__logo {
    min-width: auto;
    height: 35px;
  }

  .social-proof__logo figure {
    height: 35px;
  }

  .social-proof__logo figure img {
    max-height: 35px;
  }

  .linea-divisor {
    width: 50px;
    height: 3px;
    margin: 5px 0;
  }

  .social-proof__text {
    width: 100%;
    max-width: 280px;
    text-align: center;
    min-height: auto;
  }

  .social-proof__text p {
    font-size: 12px;
    line-height: 1.4;
  }
}

@media screen and (max-width: 490px) {
  .grid-efi {
    margin-top: 40px;
  }

  .hero-image {
    width: 85vw;
    height: 260px;
  }

  .notification-card {
    padding: 10px 12px;
    gap: 8px;
  }

  .notification-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }

  .notification-content strong {
    font-size: 13px;
  }

  .notification-content p {
    font-size: 11px !important;
  }
}
</style>